module.exports = __webpack_public_path__ + "static/media/dent.79484870.png";